import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import {
  BdcPropertyProductDialogComponent,
  BDCPropertyProductDialogParams,
} from './bdc-property-product-dialog.component'

@Injectable()
export class BdcPropertyProductDialogService {
  constructor(private dialog: MatDialog) {}

  open(data: BDCPropertyProductDialogParams) {
    const defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      panelClass: ['fixed-modal'],
      data: { ...data },
    }

    return this.dialog.open(BdcPropertyProductDialogComponent, defaultConfig)
  }
}
